import type { ReactNode } from "react";

import type { ShippingMethodCodeFieldOption } from "@checkout-v2/formFields/factories/shippingMethodCodeFieldFactory";

export type DeliveryInformationProps = {
  methods: ShippingMethodCodeFieldOption[];
  selectedValue: string;
  onMethodChange: (value: string) => void;
  isShippingAgeVerificationEnabled?: boolean;
  isAgeVerified?: boolean;
  hasCompletedAgeVerification?: boolean;
  isAgeVerificationError?: boolean;
  isAgeVerificationPending?: boolean;
  onVerifyAge?: () => void;
  name?: string;
  children?: ReactNode;
};
